import {Component, Input, OnDestroy} from '@angular/core';

@Component({
	selector: 'block-ui',
	templateUrl: './block-ui.component.html',
	styleUrls: ['./block-ui.component.scss'],
	providers: [  ]
})
export class BlockUIComponent implements OnDestroy {
    private currentTimeout: number;
    public isBlocked: boolean = false;

    @Input()
    public delay: number = 0;

    @Input()
    public set blocked(value: boolean) {
        if (!value) {
            this.cancelTimeout();
            this.isBlocked = false;
            return;
        }

        if (this.currentTimeout) {
            return;
        }

        this.currentTimeout = window.setTimeout(() => {
            this.isBlocked = value;
            this.cancelTimeout();
        }, this.delay);
    }

    private cancelTimeout(): void {
        clearTimeout(this.currentTimeout);
        this.currentTimeout = undefined;
    }

    ngOnDestroy(): any {
        this.cancelTimeout();
    }
}